var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['aside',_vm.isCollapse ? 'collapse':'expand']},[_c('div',{staticClass:"toggle",on:{"click":_vm.handleToggle}},[_c('i',{staticClass:"toggle-icon",class:_vm.iconClass})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }